<template>
  <v-app id="v-app">
      <Loading v-show="loading"></Loading>
      <Header></Header>
      <router-view v-show="!loading"></router-view>
  </v-app>
</template>

<script>

import Loading from '@/components/Loading'
import Header from '@/components/Header'

export default {
  name: 'App',
  data() {
    return {
      loading: true,
    }
  },
  beforeCreate() {
  },
  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  },
  components: {
    Loading,
    Header,
  },
};
</script>

<style>
#v-app a {
  color: #333;
}
</style>